module.exports = __webpack_public_path__ + "img/31200.14e135a2.jpg";